export default "__VITE_ASSET__jTa1JBwH__"